if (!customElements.get('skn-kakadu-editorial')) {
  customElements.define('skn-kakadu-editorial', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.animations = [];
      this.observers = [];
      const arrow = this.querySelector('.skn-kakadu__connector');
      const stage = this.closest('.skn-kakadu-reference')?.querySelector('.kk__stage');
      const accent = this.querySelector('.skn-kakadu__accent');
      const layoutArrow = () => {
        if (!arrow || !stage || !accent) return;
        const r=this.getBoundingClientRect(), a=accent.getBoundingClientRect(), s=stage.getBoundingClientRect();
        const narrow=innerWidth<1000;
        const x=a.right-r.left+10, y=a.top-r.top+a.height*.55;
        const ex=s.left-r.left+s.width*(narrow?.94:.76), ey=s.top-r.top+(narrow?65:45);
        const cx=narrow?r.width+8:Math.min(r.width-20,Math.max(x+180,ex+100));
        arrow.setAttribute('width',r.width);
        arrow.setAttribute('height',Math.max(r.height,ey+20));
        arrow.querySelector('[data-kakadu-draw]').setAttribute('d',`M ${x} ${y} C ${cx} ${y-40}, ${cx} ${ey-75}, ${ex} ${ey}`);
        const dx=ex-cx,dy=75,len=Math.hypot(dx,dy),ux=dx/len,uy=dy/len;
        arrow.querySelector('[data-kakadu-arrowhead]').setAttribute('d',`M ${ex-ux*13-uy*6} ${ey-uy*13+ux*6} L ${ex} ${ey} L ${ex-ux*13+uy*6} ${ey-uy*13-ux*6}`);
        arrow.setAttribute('data-ready','');
      };
      if(window.ResizeObserver){
        this.arrowResize=new ResizeObserver(layoutArrow);
        this.arrowResize.observe(this);
        if(stage)this.arrowResize.observe(stage);
      }
      window.addEventListener('resize',layoutArrow,{passive:true,signal:this.controller.signal});
      document.fonts?.ready.then(()=>{if(this.isConnected)layoutArrow();});
      layoutArrow();
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      if (motion.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
      const make = (element, keyframes, options) => {
        const animation = element.animate(keyframes, {duration:1200,easing:'cubic-bezier(.17,.84,.44,1)',fill:'both',...options});
        animation.pause();
        animation.currentTime = 0;
        animation.onfinish = () => animation.cancel();
        this.animations.push(animation);
        return animation;
      };
      const observe = (target, animations, rootMargin = '0px 0px -20% 0px') => {
        if (!target) return;
        const observer = new IntersectionObserver(entries => {
          if (!entries.some(entry => entry.isIntersecting)) return;
          animations.forEach(animation => animation.play());
          observer.disconnect();
        }, {rootMargin,threshold:0});
        observer.observe(target);
        this.observers.push(observer);
      };
      const words = [...this.querySelectorAll('[data-kakadu-word]')].map((word,index) =>
        make(word,[{transform:'translateY(105%)'},{transform:'translateY(0)'}],{delay:index * 100})
      );
      observe(this.querySelector('.skn-kakadu__title'),words);
      if (this.hasAttribute('data-kakadu-hover-replay')) {
        const replay = event => {
          if (motion.matches || words.some(animation => animation.playState === 'running')) return;
          if (event.type === 'pointerenter' && (event.pointerType !== 'mouse' || !matchMedia('(hover: hover)').matches)) return;
          if (event.type === 'pointerdown' && event.pointerType === 'mouse') return;
          words.forEach(animation => { animation.currentTime = 0; animation.play(); });
        };
        this.addEventListener('pointerenter', replay, {signal:this.controller.signal});
        this.addEventListener('pointerdown', replay, {signal:this.controller.signal});
      }
      this.querySelectorAll('.skn-kakadu__arrow').forEach(arrow => {
        const path = arrow.querySelector('[data-kakadu-draw]');
        const head = arrow.querySelector('[data-kakadu-arrowhead]');
        const duration = arrow.classList.contains('skn-kakadu__arrow--mobile') ? 1200 : 1400;
        observe(arrow,[
          make(path,[{strokeDasharray:'1 1',strokeDashoffset:1},{strokeDasharray:'1 1',strokeDashoffset:0}],{duration,easing:'cubic-bezier(.4,0,.2,1)'}),
          make(head,[{opacity:0},{opacity:1}],{duration:200,delay:duration-200,easing:'linear'})
        ]);
      });
      this.querySelectorAll('[data-kakadu-reveal]').forEach(element => {
        observe(element,[make(element,[{opacity:0,transform:'translateY(40px)'},{opacity:1,transform:'translateY(0)'}],{})],'0px 0px -8% 0px');
      });
      const finish = () => {
        this.observers.forEach(observer => observer.disconnect());
        this.animations.forEach(animation => animation.cancel());
      };
      motion.addEventListener('change',event => {if(event.matches) finish();},{signal:this.controller.signal});
      this.addEventListener('focusin',finish,{once:true,signal:this.controller.signal});
    }
    disconnectedCallback() {
      this.arrowResize?.disconnect();
      this.controller?.abort();
      this.observers?.forEach(observer => observer.disconnect());
      this.animations?.forEach(animation => animation.cancel());
    }
  });
}

if(!customElements.get('skn-vita-reveal')){
customElements.define('skn-vita-reveal',class extends HTMLElement{
 connectedCallback(){
  if(matchMedia('(prefers-reduced-motion: reduce)').matches||!window.IntersectionObserver||!Element.prototype.animate)return;
  this.motion=matchMedia('(prefers-reduced-motion: reduce)');
  this.animations=[...this.querySelectorAll('.skn-vita-line')].map((line,i)=>{
   const a=line.animate([{transform:'translateY(120%)'},{transform:'translateY(0)'}],{duration:1200,delay:i*140,easing:'cubic-bezier(.17,.84,.44,1)',fill:'both'});a.pause();a.currentTime=0;a.onfinish=()=>a.cancel();return a;
  });
  this.observer=new IntersectionObserver(entries=>{if(entries.some(e=>e.isIntersecting)){this.animations.forEach(a=>a.play());this.observer.disconnect();}},{rootMargin:'0px 0px -12% 0px'});
  this.observer.observe(this);
  this.finish=()=>{this.observer.disconnect();this.animations.forEach(a=>a.cancel());};
  this.motion.addEventListener('change',this.finish);
 }
 disconnectedCallback(){this.finish?.();this.motion?.removeEventListener('change',this.finish);}
});
}

